import { Typography, Tooltip, Box } from "@mui/material";
import { useState } from "react";
import { useAppTranslation } from "../../hooks/useAppTranslation";

type Props = {
  text?: string | null;
  maxLines?: number; // ile linii w collapsed
};

export default function ExpandableText({
  text,
  maxLines = 1,
}: Props) {
  const { t } = useAppTranslation("common");

  const [expanded, setExpanded] = useState(false);

  const expandedText = t("Kliknij aby zwinąć");
  const collapsedText = t("Kliknij aby rozwinąć");

  if (!text) {
    return <Typography variant="body2" component="span">—</Typography>;
  }

  const isLong = text.length > 60;

  return (
    <Tooltip
      title={isLong
            ? expanded
            ? expandedText
            : collapsedText
            : ""
        }
      arrow
      placement="top-start"
    >
      <Box
        onClick={() => isLong && setExpanded((prev) => !prev)}
        sx={{
          cursor: isLong ? "pointer" : "default",
          minWidth: 0, // 🔥 ważne dla ellipsis w gridzie
        }}
      >
        <Typography
          variant="body2"
          component="span"
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",

            ...(expanded
              ? {
                  whiteSpace: "pre-wrap",
                }
              : {
                  display: "-webkit-box",
                  WebkitLineClamp: maxLines,
                  WebkitBoxOrient: "vertical",
                  whiteSpace: "normal",
                }),

            transition: "all 0.2s ease",

            // 👇 subtelny hover hint
            "&:hover": {
              backgroundColor: isLong ? "action.hover" : "transparent",
              borderRadius: 1,
            },
          }}
        >
          {text}
        </Typography>
      </Box>
    </Tooltip>
  );
}